import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  Auth,
  browserLocalPersistence,
  getAuth,
  initializeAuth,
  onAuthStateChanged,
  setPersistence,
  signInWithCredential,
  signInWithCustomToken,
  UserCredential,
} from 'firebase/auth';

// Inizializzazione di Firebase client-side con i parametri env
export async function initializeFirebaseClient() {
  if (!getApps().length) {
    initializeApp({
      apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
      authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
      storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    });

    const app = getApp();
    const auth = getAuth(app);

    await setPersistence(auth, browserLocalPersistence).then(() => {
      console.log('🔥 Firebase Initialized with browserLocalPersistence.');
    });

    console.log('🔥 Firebase Initialized with browserLocalPersistence.');
  }
}

// Restituisce l'istanza di autenticazione di Firebase
export const getFirebaseAuth = async (): Promise<Auth> => {
  await initializeFirebaseClient();

  const app = getApp();
  const auth = getAuth(app); // Now safe to call getAuth

  // await setPersistence(auth, browserLocalPersistence);
  // console.log('Auth initialized:', auth); // Verifica che l'istanza di auth sia valida
  return new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log('✅ Utente autenticato:', user);
      } else {
        console.log('❌ Nessun utente autenticato.');
      }

      resolve(auth);
    });
  });
};
